import { toast } from "react-toastify";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { getOriginRegionByRoutingWithEquipment } from "./GetOriginRegionByRoutingWithEquipment";
import { setEffectiveSupplierAndDestinationRouting } from "./SetEffectiveSupplierAndDestinationRouting";

export async function getRouteWithOriginRegion(
  route: FtlRouteViewModel,
  startDateDisplay: string | undefined
) {
  const currentRoute = { ...route };
  const routings = currentRoute.RoutingTable;
  const routingCount = routings?.length;

  if (!routings || !routingCount || routingCount < 1 || startDateDisplay === undefined) {
    currentRoute.OriginRegion = undefined;
    return currentRoute;
  }

  const { supplierRouting, destinationRouting } = setEffectiveSupplierAndDestinationRouting(
    routings,
    currentRoute
  );
  if (!supplierRouting || !destinationRouting || supplierRouting === destinationRouting) {
    currentRoute.OriginRegion = undefined;
    return currentRoute;
  }

  const fetchedOriginRegion = await getOriginRegionByRoutingWithEquipment(
    supplierRouting.Gsdb,
    destinationRouting.Gsdb,
    currentRoute.Equipment,
    startDateDisplay
  );

  if (!fetchedOriginRegion) {
    toast.warning("No Bidpack available for this Equipment");
  }

  if (
    !currentRoute.OriginRegion ||
    currentRoute.OriginRegion.OriginRegionID !== fetchedOriginRegion?.OriginRegionID
  ) {
    currentRoute.CarrierInformationIsModified = true;
  }

  return { ...currentRoute, OriginRegion: fetchedOriginRegion };
}
